import { AnyAction, Dispatch, MiddlewareAPI } from 'redux';

function isErrorType(type: string) {
  return type.startsWith('FETCH_') && type.endsWith('_ERROR');
}

export const errorMiddleware = (api: MiddlewareAPI) => (
  next: Dispatch<AnyAction>
) => (action: AnyAction) => {
  //TODO: Add handling for other status codes?
  if (isErrorType(action.type) && action.error.statusCode === 415) {
    //TODO: Use connected-react-router for handling errors with redux
    window.location.assign(`/415`);
  } else {
    return next(action);
  }
};
